export default __webpack_public_path__ + "static/media/watchlist-button.8bdfb498.svg";